import formatDate from 'date-fns/format';
import { handleNetworkError, showSuccessToast } from '../../utils';
import { fetchLoanApplications, markLoanApplicationAsApproved, markLoanApplicationAsDisbursed, markLoanApplicationAsBroadcasted, markLoanApplicationAsRejected, markLoanDisbursementAsRejected } from '../../services/API';

export const getLoanApplications = async ({ commit }, page = 1) => {
    commit('FETCHING_LOAN_APPLICATIONS', true);

    try {
        let {data, pagination} = await fetchLoanApplications(page);
        data = data.map(application => (
            {
                ...application, 
                createdAt: formatDate(application.createdAt, 'Do MMM YYYY'),
                updatedAt: formatDate(application.updatedAt, 'Do MMM YYYY'),
            })
        );
        commit('FETCHING_LOAN_APPLICATIONS', false);
        commit('SET_LOAN_APPLICATIONS', {data, pagination});
    } catch (error) {
        commit('FETCHING_LOAN_APPLICATIONS', false);
        handleNetworkError(error, "Error fetching supported banks:");
    }
}

export const setcurrentLoan = ({ commit }, loanApplicationId) => {
    if (!loanApplicationId){
        commit('SET_LOAN_APPLICATION_BEING_EDITED', null);
        return;
    }

    commit('SET_LOAN_APPLICATION_BEING_EDITED', loanApplicationId);
}

export const disburseLoanApplication = async ({ commit, state }, loanApplicationId) => {
    commit('SAVING_LOAN_APPLICATION', true);
    try {
        const disbursementTransaction = await markLoanApplicationAsDisbursed(loanApplicationId);
        commit('SAVING_LOAN_APPLICATION', false);

        let loanApplications = state.loanApplications;
        if (!loanApplications)
            loanApplications = [];

        loanApplications = loanApplications.map(loanApplication => {
            if (loanApplication._id === loanApplicationId){
                const updatedLoan = {
                    ...loanApplication, 
                    status: "disburseddisbursementInitiated",
                    transactions: [
                        disbursementTransaction
                    ]
                };
                return updatedLoan;
            }

            return loanApplication;
        });

        commit('SET_LOAN_APPLICATIONS', {data: loanApplications});
        showSuccessToast("Loan application disbursed");
    } catch (error) {
        handleNetworkError(error, `Error disbursing loan application:`);
        commit('SAVING_LOAN_APPLICATION', false);
    }
}

export const broadcastLoanApplication = async ({ commit, state }, {loanId, ...payload}) => {
    commit('SAVING_LOAN_APPLICATION', true);
    try {
        await markLoanApplicationAsBroadcasted(loanId, payload);
        commit('SAVING_LOAN_APPLICATION', false);

        let loanApplications = state.loanApplications;
        if (!loanApplications)
            loanApplications = [];

        loanApplications = loanApplications.map(loanApplication => {
            if (loanApplication._id === loanId)
                return {...loanApplication, status: "broadcasted"};

            return loanApplication;
        });

        commit('SET_LOAN_APPLICATIONS', {data: loanApplications});
        showSuccessToast("Loan application broadcasted");
    } catch (error) {
        handleNetworkError(error, `Error broadcasting loan application:`);
        commit('SAVING_LOAN_APPLICATION', false);
    }
}

export const rejectLoanApplication = async ({ commit, state }, loanId) => {
    commit('SAVING_LOAN_APPLICATION', true);
    try {
        await markLoanApplicationAsRejected(loanId);
        commit('SAVING_LOAN_APPLICATION', false);

        let loanApplications = state.loanApplications;
        if (!loanApplications)
            loanApplications = [];

        loanApplications = loanApplications.map(loanApplication => {
            if (loanApplication._id === loanId)
                return {...loanApplication, status: "rejected"};

            return loanApplication;
        });

        commit('SET_LOAN_APPLICATIONS', {data: loanApplications});
        showSuccessToast("Loan application rejected");
    } catch (error) {
        handleNetworkError(error, `Error rejecting loan application:`);
        commit('SAVING_LOAN_APPLICATION', false);
    }
}

export const rejectLoanDisbursement = async ({ commit, state }, {loanApplicationId, transactionId, remark}) => {
    let loanApplications = state.loanApplications;
    if(!loanApplications)
        loanApplications = [];

    function setLoanRejectionStatus(rejecting, status){
        loanApplications = loanApplications.map(loanApplication => {
            if(loanApplication._id === loanApplicationId)
                return {
                    ...loanApplication, 
                    rejecting,
                    status: status || loanApplication.status
                };

            return loanApplication;
        });
        commit('SET_LOAN_APPLICATIONS', {data: loanApplications});
    }

    try {
        setLoanRejectionStatus(true);
        await markLoanDisbursementAsRejected(transactionId, {remark});
        
        setLoanRejectionStatus(false, "rejected");
        showSuccessToast(`Loan application rejected`);
    } catch (error) {
        handleNetworkError(error, `Error rejecting loan application:`);
        setLoanRejectionStatus(false);
    }
}

export const approveLoanApplication = async ({ commit, state }, {loanApplicationId, transactionId}) => {
    let loanApplications = state.loanApplications;
    if(!loanApplications)
        loanApplications = [];

    function setLoanApprovalStatus(approving, status){
        loanApplications = loanApplications.map(loanApplication => {
            if(loanApplication._id === loanApplicationId)
                return {
                    ...loanApplication, 
                    approving,
                    status: status || loanApplication.status
                };

            return loanApplication;
        });
        commit('SET_LOAN_APPLICATIONS', {data: loanApplications});
    }

    try {
        setLoanApprovalStatus(true);
        await markLoanApplicationAsApproved(transactionId);
        
        setLoanApprovalStatus(false, "disbursementApproved");
        showSuccessToast(`Loan application approved`);
    } catch (error) {
        handleNetworkError(error, `Error approving loan application:`);
        setLoanApprovalStatus(false);
    }
}